import { render, staticRenderFns } from "./BudgetExecutionIncome.vue?vue&type=template&id=3d991b46&scoped=true&"
import script from "./BudgetExecutionIncome.vue?vue&type=script&lang=js&"
export * from "./BudgetExecutionIncome.vue?vue&type=script&lang=js&"
import style0 from "./BudgetExecutionIncome.vue?vue&type=style&index=0&id=3d991b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d991b46",
  null
  
)

export default component.exports